import { Component, input } from '@angular/core';
import { IonButton, IonContent, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { downloadOutline, refreshOutline } from 'ionicons/icons';

/**
 * Pantalla de actualización obligatoria: sin botón de cerrar (ver ForceUpdateService). La misma
 * pantalla dice "Estamos actualizando el servicio" cuando la instancia va detrás del app (TEC-296).
 */
@Component({
  selector: 'app-force-update',
  imports: [IonContent, IonButton, IonIcon],
  templateUrl: './force-update.component.html',
  styleUrls: ['./force-update.component.css'],
})
export class ForceUpdateComponent {
  readonly title = input('Actualiza la app');
  readonly message = input<string | null>(null);
  readonly buttonLabel = input('Actualizar');
  readonly icon = input('download-outline');
  /** Lo pasa ForceUpdateService: abre la tienda (sin importar el servicio aquí, para no ciclar). */
  readonly onUpdate = input<() => void>(() => undefined);

  constructor() {
    addIcons({ downloadOutline, refreshOutline });
  }

  update() {
    this.onUpdate()();
  }
}
